<template>
    <div>
        <div v-if="parameters.p_144" class="py-2">
            <strong>R1</strong>
            <b-btn v-b-toggle="'r1Pump'" variant="primary" class="collapse-btn-style" @click="r1CollapseOpen = !r1CollapseOpen">{{ r1CollapseIcon }}
            </b-btn>
            <b-collapse id="r1Pump" class="mt-2">
                <b-card style="border: none;">
                    <br>

                    <Parameter key="p_144" param-key="p_144" :param-value="parameters['p_144']"
                               :free-analogue-controller-exists="freeAnalogueControllerExists('r1')"></Parameter>

                    <div v-if="isNotPumpStandard('p_144')">
                        <Parameter v-if="categoriesLookup['Pumps'].indexOf(key) > -1 && shouldRenderParameter(key)"
                                   v-for="(value, key) in parameters" :key="key" :param-key="key" :param-value="value"></Parameter>
                    </div>

                    <Parameter key="p_49" param-key="p_49" :param-value="parameters['p_49']"
                               :free-analogue-controller-exists="freeAnalogueControllerExists('r1')"></Parameter>
                </b-card>
            </b-collapse>
        </div>
        <div v-else-if="parameters.p_144" class="py-2">
            <strong>R1 - no controller available</strong>
        </div>

        <div v-if="parameters.p_145" class="py-2">
            <strong>R2</strong>
            <b-btn v-b-toggle="'r2Pump'" variant="primary" class="collapse-btn-style" @click="r2CollapseOpen = !r2CollapseOpen">{{ r2CollapseIcon }}
            </b-btn>
            <b-collapse id="r2Pump" class="mt-2">
                <b-card style="border: none;">
                    <br>

                    <Parameter key="p_145" param-key="p_145" :param-value="parameters['p_145']"
                               :free-analogue-controller-exists="freeAnalogueControllerExists('r2')"></Parameter>

                    <div v-if="isNotPumpStandard('p_145')">
                        <Parameter v-if="categoriesLookup['Pumps'].indexOf(key) > -1 && shouldRenderParameter(key)" v-for="(value, key) in parameters"
                                   :key="key" :param-key="key" :param-value="value"></Parameter>
                    </div>

                    <Parameter key="p_50" param-key="p_50" :param-value="parameters['p_50']"
                               :free-analogue-controller-exists="freeAnalogueControllerExists('r2')"></Parameter>
                </b-card>
            </b-collapse>
        </div>
        <div v-else-if="parameters.p_145" class="py-2">
            <strong>R2 - no controller available</strong>
        </div>

        <div v-if="parameters.p_146 && !((parameters.p_144 && parameters.p_144.value == 1 ) || (parameters.p_145 && parameters.p_145.value == 1))"
             class="py-2">
            <strong>R3</strong>
            <b-btn v-b-toggle="'r3Pump'" variant="primary" class="collapse-btn-style" @click="r3CollapseOpen = !r3CollapseOpen">{{ r3CollapseIcon }}
            </b-btn>
            <b-collapse id="r3Pump" class="mt-2">
                <b-card style="border: none;">
                    <br>

                    <Parameter key="p_146" param-key="p_146" :param-value="parameters['p_146']"
                               :free-analogue-controller-exists="freeAnalogueControllerExists('r3')"></Parameter>

                    <div v-if="isNotPumpStandard('p_146')">
                        <Parameter v-if="categoriesLookup['Pumps'].indexOf(key) > -1 && shouldRenderParameter(key)"
                                   v-for="(value, key) in parameters" :key="key" :param-key="key" :param-value="value"></Parameter>
                    </div>

                    <Parameter key="p_51" param-key="p_51" :param-value="parameters['p_51']"
                               :free-analogue-controller-exists="freeAnalogueControllerExists('r3')"></Parameter>
                </b-card>
            </b-collapse>
        </div>
        <div v-else-if="parameters.p_146" class="py-2">
            <strong>R3 - no controller available</strong>
        </div>
    </div>
</template>

<script>
    import Parameter from "@/components/virtual-device/edit/parameter/v3/Parameter";
    import DeviceTemplates from "../../device-templates/DeviceTemplates";

    export default {
        name: "Pumps",

        components: {
            DeviceTemplates,
            Parameter
        },

        props: [
            'parameters',
            'categoriesLookup',
            'shouldShow',
            'shouldRenderMobileSchedule'
        ],

        data() {
            return {
                r1CollapseOpen: false,
                r2CollapseOpen: false,
                r3CollapseOpen: false
            }
        },

        computed: {
            r1CollapseIcon: function () {
                return this.r1CollapseOpen === false ? '+' : '-';
            },

            r2CollapseIcon: function () {
                return this.r2CollapseOpen === false ? '+' : '-';
            },

            r3CollapseIcon: function () {
                return this.r3CollapseOpen === false ? '+' : '-';
            }
        },

        mounted() {
            this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
                if (!isJustShown) {
                    if (collapseId === 'r1Pump') {
                        this.r1CollapseOpen = false;
                    } else if (collapseId === 'r2Pump') {
                        this.r2CollapseOpen = false;
                    } else if (collapseId === 'r3Pump') {
                        this.r3CollapseOpen = false;
                    }
                }
            })
        },

        methods: {
            freeAnalogueControllerExists(relay) {
                if (relay === "r1") {
                    return !((this.parameters.p_145 && this.parameters.p_145.value == 1) || (this.parameters.p_146 && this.parameters.p_146.value == 1));
                } else if (relay === "r2") {
                    return !((this.parameters.p_144 && this.parameters.p_144.value == 1) || (this.parameters.p_146 && this.parameters.p_146.value == 1));
                } else if (relay === "r3") {
                    return !((this.parameters.p_144 && this.parameters.p_144.value == 1) || (this.parameters.p_145 && this.parameters.p_145.value == 1));
                } else return false;
            },

            isNotPumpStandard(key) {
                return this.parameters[key].value != 0;
            },

            shouldRenderParameter(key) {
                if (this.parameters.p_134.value == 0) {
                    return !(key === 'p_138' || key === 'p_139' || key === 'p_140');
                } else if (this.parameters.p_134.value == 1) {
                    return !(key === 'p_135' || key === 'p_136' || key === 'p_137');
                } else return false;
            }
        }
    }
</script>

<style scoped>
    .collapse-btn-style {
        padding: 0rem 0.4rem;
        margin: 0px 10px 0px 10px;
        min-width: 1.5rem; /*Needed because button gets narrower when icon is changed from '+' to '-'*/
    }

    .card-body {
        padding: 0;
    }

</style>